/**
 * Confirms renewing the lease when the user clicks the expiring session timer.
 *
 * Declining does not end the session: the lease simply runs out on its own, and
 * the server is what decides that. See `useSessionCountdown`.
 */
import type { FC } from 'react';

import ConfirmationModal from 'components/molecules/common/modals/ConfirmationModal';

import { TPO_EXTEND_SESSION_MODAL } from '../../../config/testIds';
import { useTpoGenConfig } from '../../../context/CustomerConfigContext';

export interface ExtendSessionModalProps {
    open: boolean;
    planName: string;
    isExtending: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const ExtendSessionModal: FC<ExtendSessionModalProps> = ({ open, planName, isExtending, onCancel, onConfirm }) => {
    const { labels } = useTpoGenConfig();
    const editSession = labels.editSession;

    const description = (
        <div className="bg-[#fafafa] rounded-lg p-2">
            <p className="text-sm text-[#18181b]">{editSession.extendQuestion.replace('{planName}', planName)}</p>
        </div>
    );

    return (
        <ConfirmationModal
            data-testid={TPO_EXTEND_SESSION_MODAL}
            open={open}
            onCancel={onCancel}
            onSubmitClick={onConfirm}
            okText={editSession.confirmYes}
            cancelText={labels.common.cancel}
            okButtonProps={{ type: 'primary', loading: isExtending, style: { borderRadius: 6 } }}
            loading={isExtending}
            title={editSession.extendTitle}
            description={description}
            width={520}
        />
    );
};

ExtendSessionModal.displayName = 'ExtendSessionModal';
export default ExtendSessionModal;
